import script from "./chengjichaxun.vue?vue&type=script&setup=true&lang=js"
export * from "./chengjichaxun.vue?vue&type=script&setup=true&lang=js"

import "./chengjichaxun.vue?vue&type=style&index=0&id=42956942&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42956942"]])

export default __exports__